import paymentActions from './paymentActions';

export default paymentActions;
